import { useTranslation } from 'react-i18next'
import { useQueryParams } from 'use-query-params'

import { ReactComponent as Refresh } from '../../../../assets/icons/refresh.svg'
import { RulesFiltersEnum } from '../RulesFilters'

import { joinClassNames } from '../../../../utils/styles'
import styles from './rules-filters-menu.module.scss'

interface IConversationFiltersMenu {
    category: RulesFiltersEnum
    setCategory: React.Dispatch<React.SetStateAction<RulesFiltersEnum>>
}

function RulesFiltersMenu(props: IConversationFiltersMenu) {
    const { category, setCategory } = props

    const { t } = useTranslation()

    const [, setQuery] = useQueryParams()

    return (
        <div className={styles.rulesFiltersMenu}>
            <div>
                {Object.keys(RulesFiltersEnum).map((key) => {
                    const rulesFilterKey = key as keyof typeof RulesFiltersEnum

                    const rulesCategory = RulesFiltersEnum[rulesFilterKey]

                    return (
                        <button
                            className={joinClassNames(
                                styles.rulesFiltersMenu__btn,
                                category === rulesCategory &&
                                    styles.rulesFiltersMenu__btnActive
                            )}
                            onClick={() => setCategory(rulesCategory)}
                            key={key}
                        >
                            {t(rulesCategory)}
                        </button>
                    )
                })}
            </div>
            <button
                onClick={() => setQuery({}, 'replace')}
                className={styles.rulesFiltersMenu__clearBtn}
            >
                <Refresh className={styles.rulesFiltersMenu__clearBtnIcon} />
            </button>
        </div>
    )
}

export default RulesFiltersMenu
